import PageHero from '../components/PageHero';
import { CheckCircle2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

export default function About() {
  const values = [
    {
      title: 'Struktur',
      description: 'Vi tror på, at struktur er nøglen til succesfuld rådgivning og drift.'
    },
    {
      title: 'Kompetence',
      description: 'Vores fundament er bygget på høj faglighed inden for både finans og jura.'
    },
    {
      title: 'Tillid',
      description: 'Vi arbejder for at være din mest betroede samarbejdspartner.'
    },
    {
      title: 'Nærvær',
      description: 'Vi er tæt på din forretning og forstår dine udfordringer.'
    }
  ];

  return (
    <main className="bg-white">
      <SEO 
        title="Om FINANJU | Ekspertise i Krydsfeltet Mellem Finans & Jura"
        description="Læs om FINANJUs vision, værdier og erfaring. Vi leverer nærværende, struktureret og kompetent rådgivning inden for finansiel og juridisk drift."
        path="/om-finanju"
      />
      <PageHero
        title="Om FINANJU"
        subtitle="Ekspertise i krydsfeltet mellem finans og jura. Vi hjælper virksomheder med at skabe et solidt økonomisk og juridisk fundament."
        breadcrumbs={[{ name: 'Om os', href: '/om-finanju' }]}
      />

      <section className="py-24 bg-white">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-center mb-16">
            <div>
              <h2 className="text-3xl font-bold text-slate-900 mb-8">Vores Historie og Vision</h2>
              <p className="text-lg text-slate-500 leading-relaxed mb-6">
                FINANJU blev grundlagt med en vision om at tilbyde virksomheder en samlet løsning, hvor økonomisk indsigt og juridisk viden går hånd i hånd. Vi så et behov for rådgivning, der ikke blot kigger på tallene eller paragrafferne isoleret, men ser helheden i virksomhedens drift.
              </p>
              <p className="text-lg text-slate-500 leading-relaxed mb-10">
                Vi arbejder med en professionel, afdæmpet tilgang fokuseret på at skabe ro, struktur og overblik for vores kunder, så de kan drive deres virksomhed med ro i maven.
              </p>
              <div className="space-y-6 mb-12">
                {values.map((value, idx) => (
                  <div key={idx} className="flex gap-4">
                    <div className="mt-1">
                      <CheckCircle2 className="h-6 w-6 text-[#876a57]" />
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-1">{value.title}</h3>
                      <p className="text-slate-500">{value.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <Link to="/kontakt" className="cta-button">
                Få en uforpligtende dialog
              </Link>
            </div>
            <div className="mt-16 lg:mt-0 relative">
              <div className="aspect-[4/3] rounded-sm overflow-hidden bg-slate-100 shadow-2xl">
                <img
                  src="/images/desk-with-book-and-plant.png"
                  alt="Stilrent skrivebord med bog og plante"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>
          </div>

          {/* Dark CTA Box matching the other services pages */}
          <div className="bg-slate-900 rounded-sm p-12 lg:p-16 text-center shadow-lg relative overflow-hidden">
             <div className="absolute inset-0 z-0">
                <img
                  src="/images/consultation.png"
                  alt="Background"
                  className="w-full h-full object-cover opacity-10 grayscale mix-blend-multiply"
                />
             </div>
             <div className="relative z-10">
                <h3 className="text-2xl font-bold text-white mb-6">Lad os tage en dialog</h3>
                <p className="text-slate-300 mb-10 max-w-2xl mx-auto">
                  Kontakt os i dag for en uforpligtende samtale om, hvordan vi kan hjælpe din virksomhed med at skabe struktur og overblik.
                </p>
                <Link to="/kontakt" className="cta-button">
                  Kontakt FINANJU
                </Link>
             </div>
          </div>
        </div>
      </section>
    </main>
  );
}
